export const staffManagementCopy = {
  en: {
    title: 'New message',
    back: 'Back to Staff',
    compose: 'New message',
    titleLabel: 'Title',
    body: 'Message',
    audience: 'Send to',
    everyone: 'Everyone at this location',
    people: 'Person',
    teams: 'Team',
    visibility: 'Owners and managers at this location can also see this message.',
    photoUpdate: 'Share a photo update with everyone at this location',
    discardForPhotos:
      'Discard this message draft and start a separate photo update? Photos will be shared with everyone at this location.',
    options: 'More options',
    snapshot: 'Recipients are saved when you publish. Later team changes do not change who received this announcement.',
    pinned: 'Pin announcement',
    ack: 'Require acknowledgement',
    publish: 'Send',
    retry: 'Retry the same announcement',
    retryChange: 'Retry the same change',
    loading: 'Loading current staff…',
    refresh: 'Refresh',
    empty: 'No active people or teams are available.',
    error: 'The request could not be completed. Your draft is retained.',
    uncertain: 'The result could not be confirmed. Retry the same change before editing.',
    saved: 'Message sent.',
    blocked: 'Staff management requires Pro or Business and manager access.',
    moderation: 'Posting access',
    mute: 'Pause posting',
    unmute: 'Allow posting',
    muted: 'Posting paused',
    active: 'Posting allowed',
    pauseHint: 'People can still read updates when posting is paused.',
    selected: 'Select at least one person or saved team.',
    unavailable:
      'Some selected people or teams are no longer available. Clear the selection and choose recipients again.',
    clearSelection: 'Clear selected recipients',
    truncated: 'Some people or teams are not shown. Choose everyone to reach all active staff at this location.',
    offline: 'Connect to publish or change posting access. Your draft stays here while this page is open.',
  },
  es: {
    title: 'Nuevo mensaje',
    back: 'Volver a Personal',
    compose: 'Nuevo mensaje',
    titleLabel: 'Título',
    body: 'Mensaje',
    audience: 'Enviar a',
    everyone: 'Todos en esta ubicación',
    people: 'Persona',
    teams: 'Equipo',
    visibility: 'Los propietarios y gerentes de esta ubicación también pueden ver este mensaje.',
    photoUpdate: 'Compartir una novedad con fotos con todos en esta ubicación',
    discardForPhotos:
      '¿Descartar este borrador de mensaje y empezar una novedad con fotos por separado? Las fotos se compartirán con todos en esta ubicación.',
    options: 'Más opciones',
    snapshot:
      'Los destinatarios se guardan al publicar. Los cambios posteriores del equipo no cambian quién recibió este anuncio.',
    pinned: 'Fijar anuncio',
    ack: 'Solicitar confirmación',
    publish: 'Enviar',
    retry: 'Reintentar el mismo anuncio',
    retryChange: 'Reintentar el mismo cambio',
    loading: 'Cargando el personal actual…',
    refresh: 'Actualizar',
    empty: 'No hay personas ni equipos activos disponibles.',
    error: 'No se pudo completar la solicitud. Se conserva su borrador.',
    uncertain: 'No se pudo confirmar el resultado. Reintente el mismo cambio antes de editarlo.',
    saved: 'Mensaje enviado.',
    blocked: 'La gestión del personal requiere Pro o Business y acceso de gerente.',
    moderation: 'Acceso para publicar',
    mute: 'Pausar publicaciones',
    unmute: 'Permitir publicaciones',
    muted: 'Publicaciones pausadas',
    active: 'Publicaciones permitidas',
    pauseHint: 'Las personas pueden seguir leyendo novedades cuando sus publicaciones están pausadas.',
    selected: 'Seleccione al menos una persona o un equipo guardado.',
    unavailable:
      'Algunas personas o equipos seleccionados ya no están disponibles. Borre la selección y vuelva a elegir destinatarios.',
    clearSelection: 'Borrar destinatarios seleccionados',
    truncated:
      'Algunas personas o equipos no se muestran. Elija todos para llegar a todo el personal activo en esta ubicación.',
    offline:
      'Conéctese para publicar o cambiar el acceso para publicar. Su borrador permanece aquí mientras esta página esté abierta.',
  },
} as const;
